import React, { useEffect } from "react";
import styled from "styled-components";
import IBTImage from "../assets/instant-bank-transfer.svg";
import CircledCheckImage from "../assets/circled-check.svg";
import { shallowEqual, useSelector } from "react-redux";
import { OBV_TX_TYPE } from '../constants/status';

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 32px 32px 48px 32px;
`;

export const HeaderLogo = styled.img`
  max-width: 100%;
  max-Height: 56px;
`;

const BodyWraper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: 1;
`;
const CircleCheck = styled.img`
  margin-top: 58px;
`;
const PaymentValue = styled.div`
  font-family: Roboto;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  color: #4caf50;
  margin-top: 18px;
`;
const SuccessText = styled.div`
  font-size: 18px;
  line-height: 24px;
  font-family: Roboto;
  font-weight: bold;
  color: rgab(0, 0, 0, 0.87);
  margin-top: 12px;
`;

const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const ThankText = styled.span`
  font-family: Roboto;
  font-size: 12px;
  font-height: 18px;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  margin-bottom: 14px;
`;
const ImageWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;

  img {
    width: 180px;
  }
`;

const TransactionSuccessPage = () => {
  const appStore = useSelector((state) => state, shallowEqual).app;
  const { bankLogoUrl, transactionType, transactionAmount, merchantReturnUrl } = appStore;
  let bodyText;
  if (transactionType.toUpperCase() === OBV_TX_TYPE.CREDIT) {
    bodyText = "Your withdrawal request has been processed";
  } else {
    bodyText = "Your deposit was successful";
  }

  // Redirect to merchantReturnUrl after two seconds
  useEffect(() => {
    const interval = setInterval(() => {
      window.location.href = merchantReturnUrl;
    }, 2000);
    return () => clearInterval(interval);
  }, [merchantReturnUrl])

  return (
    <PageWrapper className="success-page">
      <BodyWraper>
        <HeaderLogo src={bankLogoUrl} />
        <CircleCheck src={CircledCheckImage} alt="" />
        <PaymentValue data-test="transactionAmount">
          ${parseFloat(transactionAmount).toFixed(2, "0")}
        </PaymentValue>
        <SuccessText data-test="bodyText">{bodyText}</SuccessText>
      </BodyWraper>
      <FooterWrapper>
        <ThankText>Thanks for using:</ThankText>
        <ImageWrapper>
          <img src={IBTImage} alt="" />
        </ImageWrapper>
      </FooterWrapper>
    </PageWrapper>
  );
};

TransactionSuccessPage.propTypes = {};
TransactionSuccessPage.defaultProps = {};

export default TransactionSuccessPage;
